import React from "react";
import { usePermissions } from "react-admin";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import differenceInDays from "date-fns/differenceInDays";
import startOfMonth from "date-fns/startOfMonth";

import ChartWith30Days from "./ChartWith30Days";
import ChartByPost from "./ChartByPost";
import {
  useIsEnterprisePlan,
  useIsBusinessPlan,
} from "../../helpers/subscriptionPlan";
import { SELLER_ROLE } from "../../helpers/role";
import { useAnalyticsToken } from "../DataHooks/useAnalyticsToken";

const Root = styled("div")(({ theme }) => ({
  flexGrow: 1,
  backgroundColor: theme.palette.background.paper,
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Comp = () => {
  const { data: analyticsToken, isLoading, error } = useAnalyticsToken();
  const isEnterprisePlan = useIsEnterprisePlan();
  const isBusinessPlan = useIsBusinessPlan();
  const { permissions } = usePermissions();
  const isSeller = permissions === SELLER_ROLE;
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Something went wrong.</div>;

  const chartToken = analyticsToken.jwt;

  return (
    <Root>
      <h4>Analytics is a beta feature, feedbacks are welcome.</h4>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs charts"
        >
          <Tab label="Summary" {...a11yProps(0)} />
          <Tab label="Sales by time" {...a11yProps(1)} />
          <Tab label="Sales by Post" {...a11yProps(2)} />
          <Tab label="Monthly" {...a11yProps(3)} />
          <Tab label="Special" {...a11yProps(4)} />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <ChartWith30Days
          token={chartToken}
          chartId={process.env.REACT_APP_CHARTS_ID_ORDER_STATUS_BY_DAY}
        />
        <ChartWith30Days
          token={chartToken}
          chartId={process.env.REACT_APP_CHARTS_ID_NUMBER_OF_PAYMENTS}
        />
      </TabPanel>

      <TabPanel value={value} index={1}>
        {isSeller && (
          <>
            <ChartWith30Days
              token={chartToken}
              chartId={process.env.REACT_APP_CHARTS_ID_SALES_BY_ORDER_ITEM}
            />
            <ChartWith30Days
              enableTimeSelector
              token={chartToken}
              chartId={process.env.REACT_APP_CHARTS_ID_SALES_ITEM_TABLE}
            />
            <ChartWith30Days
              token={chartToken}
              chartId={process.env.REACT_APP_CHARTS_ID_PAYMENT_RECEIVED}
            />
            <ChartWith30Days
              token={chartToken}
              chartId={process.env.REACT_APP_CHARTS_ID_SUM_REVENUE}
            />
          </>
        )}
      </TabPanel>

      <TabPanel value={value} index={2}>
        {!isBusinessPlan && <div>This is business plan feature</div>}
        <div>{`FB post`}</div>
        {isBusinessPlan && isSeller && (
          <ChartByPost
            token={chartToken}
            chartId={process.env.REACT_APP_CHARTS_ID_SALES_BY_POST}
            title="Sales By Post"
          />
        )}
      </TabPanel>

      <TabPanel value={value} index={3}>
        {!isBusinessPlan && <div>This is business plan feature</div>}
        {isBusinessPlan && isSeller && (
          <ChartWith30Days
            maxDays={200}
            initialDays={differenceInDays(new Date(), startOfMonth(new Date()))}
            token={chartToken}
            chartId={process.env.REACT_APP_CHARTS_ID_REVENUE_MONTH}
          />
        )}
      </TabPanel>

      <TabPanel value={value} index={4}>
        {!isEnterprisePlan && (
          <div>{`Top spender 30 days (Enterprise plan)`}</div>
        )}
        {isEnterprisePlan && (
          <ChartWith30Days
            token={chartToken}
            chartId={process.env.REACT_APP_CHARTS_ID_TOP_SPENDER_30_DAYS}
          />
        )}
      </TabPanel>
    </Root>
  );
};

export default Comp;
